import { Icons } from "@/components/ui/icons";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";

export const UserAvatar = ({ avatarUrl }: { avatarUrl: string | null }) => {
  return (
    <Avatar className="h-8 w-8">
      <AvatarImage src={avatarUrl || undefined} alt="User avatar" />
      <AvatarFallback>
        <Icons.User className="h-4 w-4" />
      </AvatarFallback>
    </Avatar>
  );
};
